import AgentsViewPageV2 from './AgentsViewPageV2';

export default AgentsViewPageV2;

